import React from 'react';

import Carousel from 'components/Carousel';
import Headings from 'components/Headings';
import SeriesCard from 'components/Series/SeriesCard';

import { useJourneysQuery } from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import './style.scss';

const Series = () => {
  const { data, loading } = useJourneysQuery({
    ...useGraphaelDefaults(),
    fetchPolicy: 'cache-and-network',
  });

  if (!data || data.journeys.length < 1) {
    return null;
  }

  return (
    <>
      {!loading && data && data.journeys.length > 0 && (
        <div className="Series">
          <Headings
            title={{ id: 'components.NewExplorePage.Series.title' }}
            subtitle={{ id: 'components.NewExplorePage.Series.subtitle' }}
            config={{ titleAlignCenter: false, gap: 'gap-1' }}
          />

          <Carousel className="SeriesCarousel">
            {data?.journeys?.map((journey, key) => (
              <SeriesCard key={key} journey={journey} />
            ))}
          </Carousel>
        </div>
      )}
    </>
  );
};

export default Series;
